<div class="wrapper default-theme" [ngClass]="getClasses()">
  <app-navbar  *ngIf="mainter == true"></app-navbar>
  <main>
    <app-sidebar  *ngIf="mainter == true"></app-sidebar>
    <div class="pages container-fluid mb-3">
      <router-outlet></router-outlet>
      <hr>
      <app-footer></app-footer>
    </div>
    <div class="overlay" (click)="toggleSidebar()"></div>
  </main>
</div>
<ngx-spinner bdColor = "rgba(0,0,0,0.8)" size = "medium" color = "#ffffff" type = "pacman" [fullScreen] = "true"><p style="color: white" > Cargando... </p></ngx-spinner>

